import React from 'react';

import { cn } from '../../lib/utils';
import { formatNombre } from '../../lib/formats';

/**
 * Le verdict de caisse d'un poste (programme Stations, lot 030) : l'écart de
 * caisse en grand, puis l'écart de chaque pompiste. L'écart est rouge au-delà
 * du seuil de la station, et c'est écrit (« Au-dessus du seuil ») : la couleur
 * ne dit jamais seule l'état.
 *
 *  - `variance` : espèces comptées − espèces attendues (FCFA), `null` si inconnu ;
 *  - `threshold` : seuil de la station (FCFA) ;
 *  - `attendants` : `[{ attendant_id, attendant_name, cash_variance }]` ;
 *  - `hidden` : montants masqués (profil sans « montants visibles »).
 */
const signe = (valeur) => {
  const nombre = Number(valeur);
  if (!Number.isFinite(nombre)) return '—';
  const texte = formatNombre(Math.abs(nombre), 0);
  return nombre < 0 ? `−${texte}` : nombre > 0 ? `+${texte}` : texte;
};

export const depasseSeuil = (variance, threshold) =>
  variance !== null && variance !== undefined && Number.isFinite(Number(variance))
    && Math.abs(Number(variance)) > Number(threshold || 0);

export const VarianceVerdict = ({ variance, threshold, attendants = [], hidden = false, className }) => {
  const depasse = !hidden && depasseSeuil(variance, threshold);
  const pompistes = (attendants || []).filter(
    (item) => item.attendant_id && item.cash_variance !== null && item.cash_variance !== undefined,
  );
  return (
    <div className={cn('grid gap-2 sm:grid-cols-3', className)} role="group" aria-label="Écart de caisse">
      <div
        className={cn(
          'rounded-xl border p-3',
          depasse ? 'border-destructive/40 bg-destructive/5' : 'border-border bg-card',
        )}
      >
        <div className="text-xs font-medium text-muted-foreground">Écart de caisse</div>
        <div className={cn('text-2xl font-semibold tabular-nums', depasse && 'text-destructive')}>
          {hidden ? 'Masqué' : signe(variance)}
        </div>
        {depasse && <div className="text-xs font-medium text-destructive">Au-dessus du seuil</div>}
      </div>
      {pompistes.map((item) => (
        <div key={item.attendant_id} className="rounded-xl border border-border bg-card p-3">
          <div className="truncate text-xs font-medium text-muted-foreground">{item.attendant_name || 'Pompiste'}</div>
          <div className="text-2xl font-semibold tabular-nums">{hidden ? 'Masqué' : signe(item.cash_variance)}</div>
        </div>
      ))}
    </div>
  );
};

export default VarianceVerdict;
